import { globalOptions } from 'Dictionaries/imports/importOptionsDictionary.js';
export const options = _.merge(
    {
        parameters: {
            description: window.i18n.__(
                'Cette section vous permet de déterminer le critère sur lequel nous allons déterminer si un service existe déjà dans vos données Sellsy',
            ),
        },
        identifiers: {
            service: {
                title: window.i18n.__('Critère de comparaison pour les services'),
                multiple: false,
                choices: [
                    {
                        value: 'reference',
                        label: window.i18n.__('Référence'),
                        description: window.i18n.__(
                            'Référence ou code du service unique dans le catalogue',
                        ),
                    },
                    {
                        value: 'id',
                        label: window.i18n.__('Identifiant service'),
                        description: window.i18n.__(
                            'Récupéré depuis un export Sellsy ou depuis le catalogue',
                        ),
                    },
                ],
            },
        },
    },
    globalOptions,
);
export const defaultOptions = {
    identifiers: {
        service: ['reference'],
    },
};
